import React from 'react';
export function SkillBar (props) {
    const {name, percent} = props.skillData;
    return (
        <div className = 'skill-div mt-4'>
        <h6 className = 'skill-name ml-2'>
            {name}
        </h6>
        <div className = 'skill-progress'>
            <div className = 'progress-percent'>
            {percent}
            </div>
            <div className = 'progress-container'>
                <span className = 'progress-container-active' style = {{'width': percent}}></span>
            </div>
        </div>
    </div>
    );
}